import viewFill from "@iconify/icons-eva/eye-fill";
import stopFill from '@iconify/icons-eva/stop-circle-fill'
import downloadFill from '@iconify/icons-eva/download-fill'
import { ActionsMenu } from "src/components/Actions/ActionsMenu";
import { useCallback, useMemo,  } from "react";
import { useMutate } from "src/hooks/useFetch.hook";
import { remoteOperationTaskUrl, remoteOperationUrl } from "src/react-query/endPoints";
import { useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { tabsCurrentlyOpenedForSlice } from "src/store/tabsOpened/tabsOpened.slice";
import CircularProgress from "@mui/material/CircularProgress";

export const TransactionActionMenu = ({
  id,
  row,
  downloadInvoice,
  isGeneratingPDF = false,
  currentDownloadingId = null,
}) => {
  const { mutate, reset } = useMutate("chargers", {}, false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const queryClient = useQueryClient();
  
  const onOperationSent = (data) => {
    reset();
    mutate(
      {
        url: remoteOperationTaskUrl(row.chargepoint_id, data?.data?.taskId),
        method: "GET",
      },
      {
        onSuccess: ()=> {
          // console.log("remote stop operation done")
          queryClient.invalidateQueries("chargers");
        },
        onSettled: () => reset(),
      }
    );
  };

  const stopTransaction =()=>{    
        mutate(
          {
            url: remoteOperationUrl,
            method: "POST",
            body: { parameters: {transactionId: id}, chargerId:row.chargepoint_id, remoteOperationType: "RemoteStop" },
          },
          {
            onSuccess: onOperationSent,
          }
        );
    
  };

  const viewLogs = useCallback(() => {
    dispatch(tabsCurrentlyOpenedForSlice.actions.setTabsOpened({
      data:{dataForLogs: row},
      tabOpenedFor:"charger",
      tabOpened:"logs"
    }))
    navigate(`/charger/${row?.charge_box_pk}`)
  }, [row,navigate,dispatch]);

  const handleDownloadInvoice = useCallback(() => {
    if (!downloadInvoice) {
      return false;
    }
    downloadInvoice(row);
    return false;
  }, [downloadInvoice, row]);

  const isCurrentInvoiceLoading =
    isGeneratingPDF && currentDownloadingId === row?.transactionId;

  // transaction not completed yet - no invoice available
  const isTransactionOngoing = !row?.stoptime;
  
  const actionList = useMemo(
    () => [
      {
        id: "view",
        title: "View",
        icon: viewFill,
        routerLink: `/transactions/${id}`,
      },{
        id:"stop",
        title:"Stop",
        icon:stopFill,
        action:stopTransaction
      },
      {
        id: "viewLogs",
        title: "View  Logs",
        icon: viewFill,
        action: viewLogs,
      },
      {
        id: "downloadInvoice",
        title: isCurrentInvoiceLoading ? "Generating Invoice..." : "Download Invoice",
        icon: downloadFill,
        ...(isCurrentInvoiceLoading && {
          iconContainer: <CircularProgress size={18} thickness={4} />,
        }),
        disabled: isGeneratingPDF || isTransactionOngoing,
        action: handleDownloadInvoice,
      },
    ],
    [
      id,
      stopTransaction,
      viewLogs,
      handleDownloadInvoice,
      isGeneratingPDF,
      isCurrentInvoiceLoading,
      isTransactionOngoing,
    ]
  );
  return <ActionsMenu menuList={actionList} />;
};
